import mixpanel from 'mixpanel-browser';

if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    mixpanel.init('770c16d8c483844473bd730c9c11ef39');
} else if (process.env.REACT_APP_ENVIRONMENT === 'stage') {
    mixpanel.init('1b6cbf7fd4641052e95b117525822d37');
} else if (process.env.REACT_APP_ENVIRONMENT === 'development') {
    mixpanel.init('f2b2e88adfb6e2037e49c6fdcb3395ab');
}

let actions = {
    identify: (id) => {
        mixpanel.identify(id);
    },
    alias: (id) => {
        mixpanel.alias(id);
    },
    track: (name, props) => {
        mixpanel.track(name, props);
    },
    register: (props) => {
        mixpanel.register(props);
    },
    reset: (props) => {
        mixpanel.reset();
    },
    people: {
        set: (props) => {
            mixpanel.people.set(props);
        }
    },
    track_links: () => {
        mixpanel.track_links('#root a', 'Nav link clicked', {
            referrer: document.referrer
        });
    }
};

export let Mixpanel = actions;
